import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal, Table } from 'react-bootstrap';
import { addSessionV3 } from '../../utils/sessions';
import { success, ErrorMsg } from '../../utils/Toast';
import GetLessonId from '../shared/GetLessonId';
import { HomePage } from '../../translations/trans';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import InfoNote from '../shared/InfoNote';

function AddMeetingRoomV3({ packClass }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [note, setNote] = useState("");
  const [lesson, setLesson] = useState(null);
  const [isOn, setIsOn] = useState(false);
  const [homeWork, setHomework] = useState("");
  const [packageData, setPackageData] = useState(null);
  const [sendNotification, setSendNotification] = useState(false);
  const [sendVia, setSendVia] = useState("email");
  const [applyHWcheck, setApplyHWcheck] = useState(true);

  const [date, setDate] = useState(new Date());
  const [homeWorkDeadline, setHomeWorkDeadline] = useState(new Date());

  const { packages } = useSelector(({ packages }) => ({ packages }));
  const { lang, dir,user } = useSelector(({ language,loggedUser }) => ({
    lang: language.lang,
    dir: language.dir,
    user: loggedUser.user
  }));

  const handleAddRoom = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const toggleSwitch = () => setIsOn(!isOn);
  const toggleHWcheck = () => setApplyHWcheck((prev) => !prev);

  const fetchPackage = async () => {
    const pack = packages.find(p => p._id === packClass.packID);
    setPackageData(pack);
  };

  useEffect(() => {
    fetchPackage();
  }, [packClass, packages]);

  const createSession = async () => {
    try {
      setLoading(true);
      const formatDate = (d) => {
        const adjustedDate = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
        return adjustedDate.toISOString().split('.')[0] + '+03:00';
      };

      const formattedDate = formatDate(date);
      const formattedDeadline = homeWork ? formatDate(homeWorkDeadline) : null;

      const res = await addSessionV3({
        userId: user._id,
        note,
        date: formattedDate,
        materialCode: packageData?.materialCode,
        lesson,
        classId: packClass._id,
        duration: "120",
        settings: { auto_recording: isOn ? "cloud" : "local" },
        homeWorkTask: homeWork,
        homeWorkDeadline: formattedDeadline,
        alert: sendNotification === "true" ? true : false,
        sendVia,
        applyHWcheck,
      });

      setLoading(false);
      if (res?.data?.case) {
        handleCloseModal();
        success(res?.data?.message);
      } else {
        ErrorMsg(res?.data?.message);
      }
    } catch (e) {
      setLoading(false);
      console.error(e);
      ErrorMsg(e?.response?.data?.message || "Error creating session");
    }
  };

  return (
    <div>
      <Button
        onClick={handleAddRoom}
        className="btn"
        style={{ background: "#4169E2" }}
      >
        {HomePage.createSession[lang]}
      </Button>

      <Modal show={showModal} className="py-3" onHide={handleCloseModal} size="xl" dir={dir}>
        <Table responsive className="mt-5 py-3 text-center">
          <thead className="text-center">
       
            <tr>
              <th>
                {HomePage.lessonName[lang]} <InfoNote note="Select the lesson this session belongs to." />
              </th>
              <th>
                {HomePage.homeWork[lang]} <InfoNote note="Enter the homework task and set a deadline for submission." />
              </th>
              <th>
                {HomePage.dateAndTime[lang]} <InfoNote note="Pick the start date and time for this Zoom session." />
              </th>
              <th>
                {HomePage.materialRecord[lang]} <InfoNote note="Toggle between saving recordings locally or to the Zoom cloud." />
              </th>
              <th>
                {HomePage.addNote[lang]} <InfoNote note="Add a short note or description for the session. This will appear as the meeting topic." />
              </th>
              <th>
                Notification <InfoNote note="Enable this to send notifications to students about the new session." />
              </th>
              {sendNotification === "true" && (
                <th>
                  Send Via <InfoNote note="Choose whether to send the session link via WhatsApp or Email." />
                </th>
              )}
              <th>
                HW Check <InfoNote note="If enabled, only students who attended the last session or submitted homework will receive notifications." />
              </th>
            </tr>
          </thead>

          <tbody className="text-center">
            <tr>
              {/* Lesson */}
              <td>
                <select
                  style={{ border: "none" }}
                  value={lesson || ""}
                  onChange={(e) => setLesson(e.target.value)}
                >
                  <option hidden>{HomePage.lessonName[lang]}</option>
                  {packageData?.selectedLessons?.map((lesson) => (
                    <option key={lesson} value={lesson}>
                      <GetLessonId lessonId={lesson} />
                    </option>
                  ))}
                </select>
              </td>

              {/* Homework */}
              <td>
                <input
                  type="text"
                  name="homeWork"
                  id="homeWork"
                  value={homeWork}
                  className="form-control mb-2"
                  onChange={(e) => setHomework(e.target.value)}
                />
                <DatePicker
                  selected={homeWorkDeadline}
                  onChange={(date) => setHomeWorkDeadline(date)}
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  dateFormat="yyyy-MM-dd HH:mm"
                  className="form-control"
                  placeholderText="Select deadline"
                />
              </td>

              {/* Date */}
              <td>
                <DatePicker
                  selected={date}
                  onChange={(d) => setDate(d)}
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  dateFormat="yyyy-MM-dd HH:mm"
                  className="form-control"
                  placeholderText="Select date and time"
                />
              </td>

              {/* Record Toggle */}
              <td>
                <div
                  onClick={toggleSwitch}
                  style={{
                    width: "50px",
                    height: "25px",
                    background: isOn ? "#120C54" : "gray",
                    borderRadius: "15px",
                    position: "relative",
                    cursor: "pointer",
                  }}
                >
                  <div
                    style={{
                      width: "20px",
                      height: "20px",
                      background: "white",
                      borderRadius: "50%",
                      position: "absolute",
                      top: "2.5px",
                      left: isOn ? "27px" : "2.5px",
                      transition: "left 0.2s",
                    }}
                  ></div>
                </div>
              </td>

              {/* Note */}
              <td>
                <textarea
                  rows="2"
                  cols="15"
                  onChange={(e) => setNote(e.target.value)}
                  value={note}
                  style={{
                    border: "0.5px solid",
                    resize: "none",
                    backgroundColor: "white",
                    borderRadius: "5px",
                    outline: "none",
                  }}
                ></textarea>
              </td>

              {/* Notification */}
              <td>
                <select
                  className="form-control"
                  value={sendNotification}
                  onChange={(e) => setSendNotification(e.target.value)}
                >
                  <option hidden>Send Whats Notification</option>
                  <option value="true">Send Notification</option>
                  <option value="false">No Send Notification</option>
                </select>
              </td>

              {/* Send Via */}
              {sendNotification === "true" && (
                <td>
                  <select
                    className="form-control"
                    value={sendVia}
                    onChange={(e) => setSendVia(e.target.value)}
                  >
                    <option hidden>Send Notification By</option>
                    <option value="whatsapp">WhatsApp</option>
                    <option value="email">Email</option>
                  </select>
                </td>
              )}

              {/* Apply HW Check Toggle */}
              <td>
                <div
                  onClick={toggleHWcheck}
                  style={{
                    width: "50px",
                    height: "25px",
                    background: applyHWcheck ? "#0c9c21" : "gray",
                    borderRadius: "15px",
                    position: "relative",
                    cursor: "pointer",
                  }}
                >
                  <div
                    style={{
                      width: "20px",
                      height: "20px",
                      background: "white",
                      borderRadius: "50%",
                      position: "absolute",
                      top: "2.5px",
                      left: applyHWcheck ? "27px" : "2.5px",
                      transition: "left 0.2s",
                    }}
                  ></div>
                </div>
              </td>
            </tr>
          </tbody>
        </Table>

        <button
          className="btn w-25 m-auto mb-3"
          style={{ color: "white", background: "#4169E2" }}
          disabled={loading}
          onClick={!loading ? createSession : null}
        >
          {!loading ? HomePage.create[lang] : "Loading..."}
        </button>
      </Modal>
    </div>
  );
}

export default AddMeetingRoomV3;
